<template>
  <b-modal
    v-model="isShow"
    title="Cập nhật trạng thái chuyển đổi"
    centered
    no-close-on-backdrop
    @close="onClose"
  >
    <div class="form-group">
      <label class="font-weight-bold">
        Trạng thái chuyển đổi <span class="text-danger">*</span>
      </label>
      <Select2
        v-model="selectedStatus"
        :options="statusOptions"
        placeholder="Chọn trạng thái chuyển đổi"
      />
    </div>
    <div class="text-muted mt-2">
      <i class="bx bx-info-circle"></i>
      Sẽ cập nhật cho <strong>{{ count }}</strong> công việc đã chọn.
    </div>

    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <b-button variant="danger" class="mr-2" @click="isShow = false">Huỷ bỏ</b-button>
        <b-button
          variant="primary"
          :disabled="!selectedStatus || selectedStatus === '0' || isLoading"
          @click="onSubmit"
        >
          <b-spinner v-if="isLoading" small class="mr-1" />
          Cập nhật
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { TaskUpdateTransformStatus } from '@/services/customer-support/task'
  import { showMess } from '@/config/utils'
  import { TRANSFORM_STATUS_OPTIONS } from '@/constant/customerSupport'

  export default {
    name: 'PopupUpdateTransformStatus',

    data() {
      return {
        isShow: false,
        isLoading: false,
        selectedStatus: '',
        ids: [],
        statusOptions: TRANSFORM_STATUS_OPTIONS,
      }
    },

    computed: {
      count() {
        return this.ids.length
      },
    },

    methods: {
      show(ids = []) {
        this.ids = ids
        this.selectedStatus = ''
        this.isShow = true
      },

      close() {
        this.isShow = false
      },

      onClose() {
        // no-op
      },

      async onSubmit() {
        if (!this.selectedStatus || this.selectedStatus === '0') return
        try {
          this.isLoading = true
          const res = await TaskUpdateTransformStatus({
            ids: this.ids,
            transformStatus: this.selectedStatus,
          })
          if (res.result || res.code === 1000) {
            showMess(
              this,
              'Thông báo',
              res.message || 'Cập nhật thành công!',
              'success',
              'b-toaster-top-right',
              3000
            )
            this.isShow = false
            this.$emit('success')
          } else {
            showMess(
              this,
              'Thông báo',
              res.message || 'Cập nhật thất bại!',
              'danger',
              'b-toaster-top-right',
              5000
            )
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.data?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5000
          )
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .btn + .btn {
    margin-left: 10px;
  }
</style>
